// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"40":"59789c01","63":"e799f0e6","90":"facd0ddb","330":"bda69632","334":"2d155b72","573":"fd6e9333","592":"9b891591","639":"4e34823f","647":"c3c4f7c8","983":"76135c27"}[chunkId] + ".chunk.js";
};